import {
  FavoritesAPIType,
  FavoritesTypename,
  FloorTypename,
  FloorsAPIType,
  ProductPositionTypename,
  ProductPositionsAPIType,
  ProjectTypename,
  ProjectsAPIType,
  RoomTypename,
  RoomsAPIType,
  ShareLinkTypename
} from "shared/types/Project"
import { ShareLinksAPIType } from "shared/types/ShareLink"

import {
  ClarificationRequestTypename,
  ClarificationRequestsAPIType
} from "entities/clarification-requests/types/ClarificationRequest"

export function mapTypenameToAPIType(
  typename: string | undefined
): string | null {
  switch (typename) {
    case ProjectTypename:
      return ProjectsAPIType
    case FloorTypename:
      return FloorsAPIType
    case RoomTypename:
      return RoomsAPIType
    case ProductPositionTypename:
      return ProductPositionsAPIType
    case FavoritesTypename:
      return FavoritesAPIType
    case ShareLinkTypename:
      return ShareLinksAPIType
    case ClarificationRequestTypename:
      return ClarificationRequestsAPIType
    default:
      return null
  }
}

export function mapTypenameToResourceType(
  typename: string | undefined
): string | null {
  return mapTypenameToAPIType(typename)?.replace("_", "-") ?? null
}
